import React from 'react';
import { capitalizeFirstLetter } from '../../../utils/utils';
import './FundingReviewPage.scss';

function FundingReviewPage({
  transferFromFirmName,
  transferFromAccountType,
  transferFromAccountNumber,
  transferFromAccountOwner,
  transferTofirmName,
  transferToAccountType,
  transferToAccountNumber,
  transferCD,
  transferCDTimeFrame,
  transferAmountInstructions,
  transferCDCashAssets,
  uponMaturity,
  transferPartialCashAssets,
  transferPartialSecurities,
  transferPartialSecurityDetails,
}) {
  return (
    <div className="transfer-review-details">
      <h1 className="transfer-review-details_title">
        Review your transfer details
      </h1>{' '}
      <div className="transfer-review-details_transferTo">
        <h1 className="transfer-review-details_transferTo-title">
          Transfer To :
        </h1>
        <table className="transfer-review-details_table">
          <tbody>
            <tr className="transfer-review-details_transferTo-details">
              <td className="transfer-review-details_transferTo-details-first">
                Firm Name
              </td>
              <td className="transfer-review-details_transferTo-details-second">
                {transferTofirmName}
              </td>
            </tr>
            <tr className="transfer-review-details_transferTo-details">
              <td className="transfer-review-details_transferTo-details-first">
                Account Type
              </td>
              <td className="transfer-review-details_transferTo-details-second">
                {transferToAccountType}
              </td>
            </tr>
            <tr className="transfer-review-details_transferTo-details">
              <td className="transfer-review-details_transferTo-details-first">
                Account Number
              </td>
              <td className="transfer-review-details_transferTo-details-second blocked_data">
                {`${transferToAccountNumber}`}
              </td>
            </tr>
            <tr className="transfer-review-details_transferFrom-details">
              <td className="transfer-review-details_transferFrom-details-first">
                {`Account Owner(s)`}
              </td>
              <td className="transfer-review-details_transferFrom-details-second blocked_data">
                {transferFromAccountOwner}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="transfer-review-details_transferFrom">
        <h1 className="transfer-review-details_transferFrom-title">
          Transfer From :
        </h1>
        <table className="transfer-review-details_table">
          <tbody>
            <tr className="transfer-review-details_transferFrom-details">
              <td className="transfer-review-details_transferFrom-details-first">
                Firm Name
              </td>
              <td className="transfer-review-details_transferFrom-details-second">
                {transferFromFirmName}
              </td>
            </tr>
            <tr className="transfer-review-details_transferFrom-details">
              <td className="transfer-review-details_transferFrom-details-first">
                Account Type
              </td>
              <td className="transfer-review-details_transferFrom-details-second">
                {transferFromAccountType}
              </td>
            </tr>
            <tr className="transfer-review-details_transferFrom-details">
              <td className="transfer-review-details_transferFrom-details-first">
                Account Number
              </td>
              <td className="transfer-review-details_transferFrom-details-second blocked_data">
                {transferFromAccountNumber}
              </td>
            </tr>
            {transferCD && (
              <tr className="transfer-review-details_transferFrom-details">
                <td className="transfer-review-details_transferFrom-details-first">
                  Includes Bank CDs
                </td>
                <td className="transfer-review-details_transferFrom-details-second">
                  Yes
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="transfer-review-details_transferAmount">
        {' '}
        <h1 className="transfer-review-details_transferAmount-title">
          Transfer Amount :
        </h1>
        <table className="transfer-review-details_table">
          <tbody>
            <tr className="transfer-review-details_transferAmount-details">
              <td className="transfer-review-details_transferAmount-details-first">
                Transfer Instructions
              </td>
              <td className="transfer-review-details_transferAmount-details-second">
                {transferAmountInstructions === 'FULL'
                  ? 'Full  Transfer'
                  : transferAmountInstructions === 'PARTIAL'
                  ? 'Partial  Transfer'
                  : null}
              </td>
            </tr>
            {!transferCD &&
              transferAmountInstructions === 'PARTIAL' &&
              (transferPartialCashAssets ||
                transferPartialCashAssets === 0) && (
                <tr className="transfer-review-details_transferAmount-details">
                  <td className="transfer-review-details_transferAmount-details-first">
                    Cash Assets
                  </td>
                  <td className="transfer-review-details_transferAmount-details-second">
                    {`$${transferPartialCashAssets}`}
                  </td>
                </tr>
              )}
            {!transferCD &&
              transferAmountInstructions === 'PARTIAL' &&
              transferPartialSecurities && (
                <>
                  {transferPartialSecurityDetails.map((item) => {
                    return (
                      <>
                        <tr
                          key={item.securityTicker}
                          className="transfer-review-details_transferAmount-details"
                        >
                          <td className="transfer-review-details_transferAmount-details-first">
                            {item.securityTicker}
                          </td>
                          <td className="transfer-review-details_transferAmount-details-second">
                            {item.securityQuantity === 'All Shares'
                              ? 'All Shares'
                              : `${item.securityQuantity} Shares`}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              )}
            {transferAmountInstructions === 'PARTIAL' && transferCD && (
              <tr className="transfer-review-details_transferAmount-details">
                <td className="transfer-review-details_transferAmount-details-first">
                  Bank CD Value ($)
                </td>
                <td className="transfer-review-details_transferAmount-details-second">
                  {transferCDCashAssets === 'All Cash'
                    ? transferCDCashAssets
                    : `$${transferCDCashAssets}`}
                </td>
              </tr>
            )}
            {transferCD && (
              <tr className="transfer-review-details_transferAmount-details">
                <td className="transfer-review-details_transferAmount-details-first">
                  Liquidation Time Frame
                </td>
                <td className="transfer-review-details_transferAmount-details-second">
                  {transferCDTimeFrame === 'UPON_MATURITY'
                    ? 'Upon Maturity'
                    : capitalizeFirstLetter(transferCDTimeFrame)}
                </td>
              </tr>
            )}
            {transferCDTimeFrame === 'UPON_MATURITY' && transferCD && (
              <tr className="transfer-review-details_transferAmount-details">
                <td className="transfer-review-details_transferAmount-details-first">
                  Maturity Date
                </td>
                <td className="transfer-review-details_transferAmount-details-second">
                  {uponMaturity}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default FundingReviewPage;
